import { combineReducers } from '@reduxjs/toolkit';

import tabSlice from 'shared/product_tabs/tabs/tabSlice';
import alertSlice from 'shared/product_tabs/alert/alertSlice';
import cartSlice from 'shared/product_tabs/cart/cartSlice';
import assemblySlice from 'shared/product_tabs/tab_assembly/slice/assemblySlice';
import stencilsSlice from 'shared/product_tabs/tab_stencils/slice/stencilsSlice';
import accessoriesSlice from 'shared/product_tabs/tab_accessories/slice/accessoriesSlice';
import bomSlice from 'shared/product_tabs/tab_parts/bomSlice';
import fabricationSlice from 'us_quickturn_prototype_pcb/pcb_fabrication/slice/fabricationSlice';

const rootReducer = combineReducers({
  fabrication: fabricationSlice,
  assembly: assemblySlice,
  stencils: stencilsSlice,
  accessories: accessoriesSlice,
  bom: bomSlice,
  tab: tabSlice,
  alert: alertSlice,
  cart: cartSlice,
});

export default rootReducer;
